export default __webpack_public_path__ + "9eb2493fb14315523a8c5b1d5389eae3.png";